
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ProductivityTip as TipType } from '@/features/shipment/constants/productivityTips';

@Component
export default class ProductivityTip extends Vue {
  @Prop({ required: true }) tip!: TipType;
}
